import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import { Bar } from 'react-chartjs-2';
import { formatMoneda } from '../../util/varios';

function MenuPresu(props) {

    let op = require('../../../src/modulos/datos');


    const imprimirClases = (reporte) => (event) => {
        event.preventDefault();
        reporte = 'ListTipoVehiculo';
        window.open(op.reportes + "reporte=" + reporte, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");

    }



    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Chart.js Line Chart',
            },
        },
    };

    const labels = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

    const data = {
        labels: labels,
        datasets: [
            {
                label: 'Recaudado',
                data: [/* props.rm.enero, props.rm.febrero, props.rm.marzo, props.rm.abril, props.rm.mayo, props.rm.junio, props.rm.julio, props.rm.agosto, props.rm.septiembre, props.rm.octubre, props.rm.noviembre, props.rm.diciembre */],
                borderColor: 'rgb(255, 99, 132)',

            },
            {
                label: 'Meta Presupuestaria',
                data: [/* props.totalpresu, props.totalpresu, props.totalpresu, props.totalpresu, props.totalpresu, props.totalpresu, props.totalpresu, props.totalpresu, props.totalpresu, props.totalpresu, props.totalpresu, props.totalpresu */],
                borderColor: 'rgb(2, 99, 132)',

            },
            {
                label: 'Presupuesto Propuesto',
                data: [/* props.datoscal.enero, props.datoscal.febrero, props.datoscal.marzo, props.datoscal.abril, props.datoscal.mayo, props.datoscal.junio, props.datoscal.julio, props.datoscal.agosto, props.datoscal.septiembre, props.datoscal.octubre, props.datoscal.noviembre, props.datoscal.diciembre */],
                borderColor: 'rgb(8, 448, 68)',

            }
        ],
    };

    const optionss = {
        plugins: {
            title: {
                display: true,
                text: 'Chart.js Bar Chart - Stacked',
            },
        },
        responsive: true,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };

    const labelss = ['Estadistica por Año'];

    const datas = {
        labels: labelss,
        datasets: [
            {
                label: 'Meta Presupuestaria',
                data: [/* props.presu */],
                backgroundColor: 'rgb(53, 162, 235)',
                stack: 'Stack 1',
            },
            {
                label: 'Recaudadacion Presupuestaria',
                data: [/* props.totalrc */],
                backgroundColor: 'rgb(75, 192, 192)',
                stack: 'Stack 0',
            },
            {
                label: 'Superávit',
                data: [/* props.totalavi */],
                backgroundColor: 'rgb(8, 448, 68)',
                stack: 'Stack 0',
            },
            {
                label: 'Por Recaudar',
                data: [/* props.totalmenos */],
                backgroundColor: 'rgb(255, 99, 132)',
                stack: 'Stack 0',
            },
        ],
    };


    return (
        <div className='tipo-letra'>
            <div className="row g-3 my-0">
                <div className="col-md-3">
                    <span className="d-inline-block" data-bs-toggle="tooltip" /* title={props.totalp} */>
                        <a className='text-light' href="#">
                            <div className="p-3 bg-primary shadow-sm d-flex justify-content-around align-items-center rounded" style={{height: "100px", minHeight: "100px"}}>
                                <div>
                                    <h3 className="fs-2">{/* {props.totalp} */}</h3>
                                    <p className="fs-5">Contribuyentes Registrados &nbsp; &nbsp;</p>
                                </div>
                                <i className="fas fa-users fs-1 second-text border rounded-full secondary-bg p-3" />
                            </div>
                        </a>
                    </span>
                </div>
                <div className="col-md-3">
                    <span className="d-inline-block" data-bs-toggle="tooltip" /* title={props.totalactivos} */>
                        <a className='text-dark' href="#">
                            <div className="p-3 bg-warning shadow-sm d-flex justify-content-around align-items-center rounded" style={{height: "100px", minHeight: "100px"}}>
                                <div>
                                    <h3 className="fs-2">{/* {props.totalactivos} */}</h3>
                                    <p className="fs-5">Contribuyentes Activos &nbsp; &nbsp;</p>
                                </div>
                                <i className="fas fa-user-check fs-1 second-text border rounded-full secondary-bg p-3" />
                            </div>
                        </a>
                    </span>
                </div>
                <div className="col-md-3">
                    <span className="d-inline-block" data-bs-toggle="tooltip" /* title={props.totalu} */>
                        <a className='text-light ' href="#">
                            <div className="p-3 bg-danger shadow-sm d-flex justify-content-around align-items-center rounded" style={{height: "100px", minHeight: "100px"}}>
                                <div>
                                    <h3 className="fs-2">{/* {props.totalu} */}</h3>
                                    <p className="fs-5">Contribuyentes Inactivos</p>
                                </div>
                                <i className="fas fa-user-times fs-1 second-text border rounded-full secondary-bg p-3" />
                            </div>
                        </a>
                    </span>
                </div>
                <div className="col-md-3">
                    <span className="d-inline-block" data-bs-toggle="tooltip" /* title={props.totalt} */>
                        <a type="button" className='text-light' /* onClick={imprimirClases('ListTipoVehiculo')} */>
                            <div className="p-3 bg-success shadow-sm d-flex justify-content-around align-items-center rounded" style={{height: "100px", minHeight: "100px"}}>
                                <div>
                                    <h3 className="fs-2">{/* {props.totalt} */}</h3>
                                    <p className="fs-5">Total Tipo de Clasificadores &nbsp; &nbsp;</p>
                                </div>
                                <i className="fas fa-print fs-1 second-text border rounded-full secondary-bg p-3" />
                            </div>
                        </a>
                    </span>
                </div>
            </div>
            <div className="row">
                <h3 className="fs-4 mb-3">Estadística</h3>
                <div className="col-md-6 h-25">
                    <Line options={options} data={data} />
                </div>
                <div className="col-md-6 h-25">
                    <Bar options={optionss} data={datas} />
                </div>
                <div className="col-md-6">
                    <div className="card">
                        <div className="card-body" style={{ fontSize: 9 }}>
                            <div className="row" style={{ padding: '0px' }}>
                                <div className="col-md-6 row" >
                                    <div className="col-md-6">
                                        <label className="fw-bold"><button type="button" className="btn btn-primary" /> Meta/P:</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="" style={{ textAlign: 'right' }}>{/* {formatMoneda(props.totalpresu.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */} </p>
                                    </div>
                                </div>
                                <div className="col-md-6 row" >
                                    <div className="col-md-6">
                                        <label className="fw-bold"><button type="button" className="btn btn-success" /> Propuesto:</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="" style={{ textAlign: 'right' }}>{/* {formatMoneda(props.datoscal.junio.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */} </p>
                                    </div>
                                </div>
                                <div className="col-md-6 row" >
                                    <div className="col-md-6">
                                        <label className="fw-bold"><button type="button" className="btn btn-danger" /> Enero:</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="" style={{ textAlign: 'right' }}>{/* {formatMoneda(props.rm.enero.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */} </p>
                                    </div>
                                </div>
                                <div className="col-md-6 row">
                                    <div className="col-md-6">
                                        <label className="fw-bold"><button type="button" className="btn btn-danger" /> Febrero:</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="" style={{ textAlign: 'right' }}>{/* {formatMoneda(props.rm.febrero.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */} </p>
                                    </div>
                                </div>
                                <div className="col-md-6 row">
                                    <div className="col-md-6">
                                        <label className="fw-bold"><button type="button" className="btn btn-danger" /> Marzo:</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="" style={{ textAlign: 'right' }}>{/* {formatMoneda(props.rm.marzo.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */} </p>
                                    </div>
                                </div>
                                <div className="col-md-6 row">
                                    <div className="col-md-6">
                                        <label className="fw-bold"><button type="button" className="btn btn-danger" /> Abril:</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="" style={{ textAlign: 'right' }}>{/* {formatMoneda(props.rm.abril.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */} </p>
                                    </div>
                                </div>
                                <div className="col-md-6 row">
                                    <div className="col-md-6">
                                        <label className="fw-bold"><button type="button" className="btn btn-danger" /> Mayo:</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="" style={{ textAlign: 'right' }}>{/* {formatMoneda(props.rm.mayo.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */} </p>
                                    </div>
                                </div>
                                <div className="col-md-6 row">
                                    <div className="col-md-6">
                                        <label className="fw-bold"><button type="button" className="btn btn-danger" /> Junio:</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="" style={{ textAlign: 'right' }}>{/* {formatMoneda(props.rm.junio.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */} </p>
                                    </div>
                                </div>
                                <div className="col-md-6 row">
                                    <div className="col-md-6">
                                        <label className="fw-bold"><button type="button" className="btn btn-danger" /> Julio:</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="" style={{ textAlign: 'right' }}>{/* {formatMoneda(props.rm.julio.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */} </p>
                                    </div>
                                </div>
                                <div className="col-md-6 row">
                                    <div className="col-md-6">
                                        <label className="fw-bold"><button type="button" className="btn btn-danger" /> Agosto:</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="" style={{ textAlign: 'right' }}>{/* {formatMoneda(props.rm.agosto.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */} </p>
                                    </div>
                                </div>
                                <div className="col-md-6 row">
                                    <div className="col-md-6">
                                        <label className="fw-bold"><button type="button" className="btn btn-danger" /> Septiembre:</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="" style={{ textAlign: 'right' }}>{/* {formatMoneda(props.rm.septiembre.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */} </p>
                                    </div>
                                </div>
                                <div className="col-md-6 row">
                                    <div className="col-md-6">
                                        <label className="fw-bold"><button type="button" className="btn btn-danger" /> Octubre:</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="" style={{ textAlign: 'right' }}>{/* {formatMoneda(props.rm.octubre.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */} </p>
                                    </div>
                                </div>
                                <div className="col-md-6 row">
                                    <div className="col-md-6">
                                        <label className="fw-bold"><button type="button" className="btn btn-danger" /> Noviembre:</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="" style={{ textAlign: 'right' }}>{/* {formatMoneda(props.rm.noviembre.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */} </p>
                                    </div>
                                </div>
                                <div className="col-md-6 row">
                                    <div className="col-md-6">
                                        <label className="fw-bold"><button type="button" className="btn btn-danger" /> Diciembre:</label>
                                    </div>
                                    <div className="col-md-6">
                                        <p className="" style={{ textAlign: 'right' }}>{/* {formatMoneda(props.rm.diciembre.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */} </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="col-md-8 mx-auto">
                        <div className="card">
                            <div className="card-body">
                                <div className="container p-0">
                                    <div className="col-md-12 row">
                                        <div className="col-md-3">
                                            <button type="button" className="btn btn-primary" data-bs-container="body" data-bs-toggle="popover" data-bs-placement="top" data-bs-content="Meta Presupuestaria">
                                            </button>
                                        </div>
                                        <div className="col-md-9">
                                            <p  style={{ textAlign: 'right' }}>{/* {formatMoneda(props.presu.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */} </p>
                                        </div>
                                    </div>
                                    <div className="col-md-12 row">
                                        <div className="col-md-3">
                                            <button type="button" className="btn btn-info" data-bs-container="body" data-bs-toggle="popover" data-bs-placement="top" data-bs-content="Recaudación Presupuestaria">
                                            </button>
                                        </div>
                                        <div className="col-md-9">
                                            <p  style={{ textAlign: 'right' }}>{/* {formatMoneda(props.totalrc.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */} </p>
                                        </div>
                                    </div>
                                    <div className="col-md-12 row">
                                        <div className="col-md-3">
                                            <button type="button" className="btn btn-success" data-bs-container="body" data-bs-toggle="popover" data-bs-placement="top" data-bs-content="Superávit">
                                            </button>
                                        </div>
                                        <div className="col-md-9">
                                            <p  style={{ textAlign: 'right' }}>{/* {formatMoneda(props.totalavi.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */} </p>
                                        </div>
                                    </div>
                                    <div className="col-md-12 row">
                                        <div className="col-md-3">
                                            <button type="button" className="btn btn-danger" data-bs-container="body" data-bs-toggle="popover" data-bs-placement="top" data-bs-content="Por Recaudar">
                                            </button>
                                        </div>
                                        <div className="col-md-9">
                                            <p  style={{ textAlign: 'right' }}>{/* {formatMoneda(props.totalmenos.toString().replace(',', '').replace('.', ','), ',', '.', 2)} */} </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    );

}

export default MenuPresu;
